import api from "@/router/api"

export default {
    getAllProyects({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesProyect.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_PROYECTS', response.data.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener los proyectos',
                })
            })
        })
    },

    findProyects({commit}, payload){

        return new Promise((resolve, reject) => {
            api.auxiliariesProyect.find(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_PROYECT', response.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener los proyectos',
                    })
                })
        })
    },

    createProyects({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesProyect.create(payload)
                .then(response => {
                    const {data} = response.data
                    commit('SET_PROYECTS', response.data.data)
                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    updateProyects({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesProyect.update(payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    deleteProyects({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.auxiliariesProyect.delete(payload.id)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(() => {
                    reject({
                        message: 'Error al eliminar el proyecto.',
                    })
                })
        })
    },
}
